import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import styles from './TileHorizontal.module.css';

const bindClasses = classNameBind.bind(styles);

const TileHorizontal = ({
  icon,
  name,
  info,
  id,
  checked,
  disabled,
  onClick,
  dataId,
}) => (
  <label
    className={bindClasses('tile', { checked, disabled })}
    data-ppuc-id={dataId}
    htmlFor={id}
  >
    <input
      type="radio"
      id={id}
      checked={checked}
      data-ppuc-id={`${dataId}.input`}
      onChange={onClick}
      disabled={disabled}
    />
    <div className={bindClasses('icon-ctn')}>
      {icon && <Icon name={icon} size="large" color="blue" />}
    </div>
    <div
      className={bindClasses('text-ctn')}
      data-ppuc-id={`${dataId}.Tile.text`}
    >
      <div
        className={bindClasses('label')}
        data-ppuc-id={`${dataId}.label`}
      >
        {name}
      </div>
      {info && (
      <div
        className={bindClasses('info')}
        data-ppuc-id={`${dataId}.info`}
      >
        {info}
      </div>
      )}
    </div>
  </label>
);

TileHorizontal.defaultProps = {
  checked: false,
  info: '',
  disabled: false,
};

export default TileHorizontal;
